// extracted by mini-css-extract-plugin
module.exports = {"NavList":"NavList_NavList__3p4Y4","ContactUs":"NavList_ContactUs__1miuV","ContactUsGap":"NavList_ContactUsGap__3MJRE"};